import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const showHideSidebar = (state, { toggleSidebar }) => {
  return state.merge({ toggleSidebar });
};

const currentViewGlobal = (state, { currentView }) => {
  return state.merge({ currentView });
};

const currentViewFactory = (state, { factoyView }) => {
  return state.merge({ factoyView });
};

const showBackFactoryBtn = (state, { showBtn }) => {
  return state.merge({ showBtn });
};

const setLoaderAfterUpdate = (state, { afterUpdateLoader }) => {
  return state.merge({ afterUpdateLoader });
};

const setAllFactories = (state, { allFactories }) => {
  if (!allFactories) return state;
  return state.merge({ allFactories });
};

const setAllSimulators = (state, { allSimulators }) => {
  if (!allSimulators) return state;
  return state.merge({ allSimulators });
};

const setAllGroups = (state, { allGroups }) => {
  if (!allGroups) return state;
  return state.merge({ allGroups });
};

const setAllDowntimeReasons = (state, { allDowntimeReasons }) => {
  if (!allDowntimeReasons) return state;
  return state.merge({ allDowntimeReasons });
};

const setEquipment = (state, { equipmentData }) => {
  if (!equipmentData) return state;
  return state.merge({ equipmentData });
};

const setAllJobTitles = (state, { allJobTitles }) => {
  if (!allJobTitles) return state;
  return state.merge({ allJobTitles });
};

const setAllFactoryDepartments = (state, { factoryDepartments }) => {
  if (!factoryDepartments) return false;
  return state.merge({ factoryDepartments });
};

const setFetchAllCrews = (state, { allFetchCrews }) => {
  if (!allFetchCrews) return state;
  return state.merge({ allFetchCrews });
};

const setAllDepartments = (state, { departmentsData }) => {
  if (!departmentsData) return false;
  return state.merge({ departmentsData });
};

const setOeeEquipmentByID = (state, { equipDataById }) => {
  if (!equipDataById) return false;
  return state.merge({ equipDataById });
};

const setAjaxCallEquipment = (state, { ajaxCallLoopEquipment }) => {
  return state.merge({ ajaxCallLoopEquipment });
};

const setAjaxCallOee = (state, { ajaxCallLoopOee }) => {
  return state.merge({ ajaxCallLoopOee });
};

const setajaxCallfactoryefficiency = (state, { ajaxCallfactoryefficiency }) => {
  return state.merge({ ajaxCallfactoryefficiency });
};

const setAjaxCallAux = (state, { ajaxCallLoopAux }) => {
  return state.merge({ ajaxCallLoopAux });
};

const setAjaxCallEnergy = (state, { ajaxCallLoopEnergy }) => {
  return state.merge({ ajaxCallLoopEnergy });
};
const setLocationHistories = (state, { locationHistories }) => {
  return state.merge({ locationHistories });
};

const incrementPendingRequests = state => {
  const currentCount = state.get('pendingRequests') || 0;
  return state.merge({ pendingRequests: currentCount + 1 });
};

const decrementPendingRequests = state => {
  const currentCount = state.get('pendingRequests') || 0;
  return state.merge({ pendingRequests: Math.max(0, currentCount - 1) });
};

export const callbacks = [
  {
    actionType: ActionTypes.SHOW_HIDE_SIDE_BAR,
    actionFunction: showHideSidebar,
  },
  {
    actionType: ActionTypes.CURRENT_VIEW_GLOBAL_DASHBOARD,
    actionFunction: currentViewGlobal,
  },
  {
    actionType: ActionTypes.CURRENT_VIEW_FACTORY_DASHBOARD,
    actionFunction: currentViewFactory,
  },
  {
    actionType: ActionTypes.SHOW_BACK_FACTORY_BUTTON,
    actionFunction: showBackFactoryBtn,
  },
  {
    actionType: ActionTypes.SET_LOADER_AFTER_UPDATE,
    actionFunction: setLoaderAfterUpdate,
  },
  {
    actionType: ActionTypes.SET_ALL_FACTORIES,
    actionFunction: setAllFactories,
  },
  {
    actionType: ActionTypes.SET_ALL_SIMULATORS,
    actionFunction: setAllSimulators,
  },
  {
    actionType: ActionTypes.SET_ALL_GROUPS,
    actionFunction: setAllGroups,
  },
  {
    actionType: ActionTypes.SET_ALL_DOWNTIME_REASONS,
    actionFunction: setAllDowntimeReasons,
  },
  {
    actionType: ActionTypes.SET_EQUIPMENT,
    actionFunction: setEquipment,
  },
  {
    actionType: ActionTypes.SET_ALL_JOBTITLES,
    actionFunction: setAllJobTitles,
  },
  {
    actionType: ActionTypes.SET_ALL_FACTORY_DEPARTMENTS,
    actionFunction: setAllFactoryDepartments,
  },
  {
    actionType: ActionTypes.SET_ALL_DEPARTMENTS,
    actionFunction: setAllDepartments,
  },
  {
    actionType: ActionTypes.SET_OEE_EQUIPMENT_BY_ID,
    actionFunction: setOeeEquipmentByID,
  },
  {
    actionType: ActionTypes.SET_AJAX_CALL_EQUIPMENT,
    actionFunction: setAjaxCallEquipment,
  },
  {
    actionType: ActionTypes.SET_AJAX_CALL_OEE,
    actionFunction: setAjaxCallOee,
  },
  {
    actionType: ActionTypes.SET_AJAX_CALL_FACTORY_EFFICIENCY,
    actionFunction: setajaxCallfactoryefficiency,
  },
  {
    actionType: ActionTypes.SET_AJAX_CALL_AUX,
    actionFunction: setAjaxCallAux,
  },
  {
    actionType: ActionTypes.SET_AJAX_CALL_ENERGY,
    actionFunction: setAjaxCallEnergy,
  },

  { actionType: ActionTypes.SET_ALL_FETCH_CREWS, actionFunction: setFetchAllCrews },
  { actionType: ActionTypes.SET_LOCATION_HISTORIES, actionFunction: setLocationHistories },
  { actionType: ActionTypes.INCREMENT_PENDING_REQUESTS, actionFunction: incrementPendingRequests },
  { actionType: ActionTypes.DECREMENT_PENDING_REQUESTS, actionFunction: decrementPendingRequests },
];
